/**
 * @file    js/global.js
 *
 * copyright (c) 2006-2014 Frank Hellenkamp [jonas@depage.net]
 *
 * @author    Frank Hellenkamp [jonas@depage.net]
 */

import $ from 'jquery';
import ScrollMagic from 'scrollmagic';
import '@accessible360/accessible-slick';
import { CountUp } from 'countup.js';
import './depage-jquery-plugins/depage-details';

var zds = (function() {
    "use strict";
    /*jslint browser: true*/
    /*global $:false */

    var baseUrl = "";
    var lang = $('html').attr('lang');
    var $main, $footer;
    var assetPath;
    var smc = new ScrollMagic.Controller();

    // local Project instance that holds all variables and public functions
    var localJS = {
        // {{{ ready
        ready: function() {
            $("html").addClass("javascript");

            baseUrl = $("head script[src*='/global.js'], head script[src*='/global.min.js'], head script[src*='/global.dev.min.js']")[0].src;
            baseUrl = baseUrl.replace(/\/js\/global(\.dev)(\.min)?\.js.*/, "");
            assetPath = baseUrl + "/js";

            localJS.setup();

            // setup global events
            $(window).on("statechangecomplete", localJS.setup);

            $main = $("main");
            $footer = $("footer");
        },
        // }}}
        // {{{ setup
        setup: function() {
            localJS.setupNavigation();
            localJS.setupScenes();
            localJS.setupSlideshow();
            localJS.setupNewsSlider();
            localJS.setupDetails();
            localJS.setupContacts();
            localJS.setupInternalLinks();
            localJS.setupDownloads();
            localJS.setupScrollButton();
            localJS.setupCountUp();
            localJS.setupMap();
            localJS.setupVarious();
        },
        // }}}
        // {{{ setupVarious
        setupVarious: function() {
            /*
            var privacyMessage = "We use cookies and similar technologies to understand how you use our services and improve your experience. By clicking 'Accept', you accept all cookies. Otherwise we use only functionally essential cookies. For more information, please see our <a href=\"{$privacyPolicyLink}\">Data Protection Policy</a>";
            if (lang == "de") {
                privacyMessage = "Um unseren Webauftritt für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Wenn Sie 'Akzeptieren' klicken, stimmen Sie der Verwendung aller Cookies zu. Andernfalls verwenden wir nur funktional unverzichtbare Cookies. Weitere Informationen, erhalten Sie in unserer <a href=\"{$privacyPolicyLink}\">Datenschutzerklärung für Webseitenbenutzer</a>.";
            }
            $("body").depageAnalytics({
                messageHtml: privacyMessage,
            });
            */

            // add click event for teaser
            $(".teaser, .wp-block-post-template .wp-block-post").click( function(e) {
                if (e.isTrigger != 3) {
                    $("a", this).not("a[rel='tag']").first().each(function() {
                        this.click();
                    });
                }
            });

            try {
                $("h1, h2, h3, h1 a, h2 a, h3 a, size-M p, .size-L p, .teaser a, .downloads a, nav.toc span").hyphenate(lang);
            } catch(e) {
            }

            // enhance tel-links
            $("a[href^='tel:']").each(function() {
                var target = "call-" + this.href.replace(/[^a-z0-9]*/gi, "");
                var link = this;

                // load in iframe to supress potential errors when protocol is not available
                var $iframe = $("<iframe name=\"" + target + "\" style=\"display: none\" aria-hidden\"true\"></iframe>").appendTo("body");
                link.target = target;
            });
        },
        // }}}
        // {{{ setupNavigation
        setupNavigation: function() {
            var $navSidebar = $("div.sidemenu");
            var $submenus = $navSidebar.find(".main-menu > .wp-block-navigation-submenu");

            $navSidebar.on("click", function() {
                $(this).toggleClass("open");
            });

            $submenus.each(function() {
                var $submenu = $(this);
                var $toggle = $('<button class="submenu-toggle" aria-expanded="false" aria-label="Untermenü ein-/ausklappen"></button>');

                $submenu.prepend($toggle);

                $toggle.on("click", function(e) {
                    e.stopPropagation();
                    if ($submenu.hasClass("open")) {
                        localJS.closeSubmenu($submenu);
                    } else {
                        localJS.openSubmenu($submenu);
                    }
                });
            });
            $(".home div.sidemenu .wp-block-navigation-submenu, .single-post div.sidemenu .wp-block-navigation-submenu:nth-child(2), .current-menu-item, .current-menu-ancestor").first().each( function() {
                localJS.openSubmenu($(this));
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest("div.sidemenu").length) {
                    $navSidebar.removeClass("open");
                }
            });
        },
        // }}}
        // {{{ open submenu
        openSubmenu: function($submenu) {
            $(".main-menu > .wp-block-navigation-submenu.open").each( function() {
                localJS.closeSubmenu($(this));
            });

            var $toggle = $submenu.children(".submenu-toggle");
            $submenu.addClass("open");
            $toggle.attr("aria-expanded", "true");
        },
        // }}}
        // {{{ close submenu
        closeSubmenu: function($submenu) {
            var $toggle = $submenu.children(".submenu-toggle");
            $submenu.removeClass("open");
            $toggle.attr("aria-expanded", "false");
        },
        // }}}
        // {{{ setupSearch
        setupSearch: function() {
            var $search = $("nav.search");
            var $searchInput = $search.find("input");

            $search.on("click", function() {
                if ($search.hasClass("active")) {
                    if ($searchInput.val() != '') {
                        $searchInput.parents("form")[0].submit();
                    }
                    $search.removeClass("active");
                } else {
                    $search.addClass("active");
                    $searchInput.focus();
                }
            });
        },
        // }}}
        // {{{ setupScenes
        setupScenes: function() {
            var smcScenes = [];
            var $newslists= $(".newslist");

            var s = new ScrollMagic.Scene({
                    offset: 100,
                })
                .addTo(smc)
                .setClassToggle("body", "scrolled");

            smcScenes.push(s);

            $(".sm-anim").each(function() {
                var el = this;
                var $el = $(this);
                var st = el.style;
                var hook = 0.7;
                var pinned = $el.hasClass("pinned");
                if ($el.is(":last-child")) {
                    hook = 0.85;
                }
                if (pinned) {
                    hook = 0;
                }

                var s = new ScrollMagic.Scene({
                        triggerElement: el,
                        triggerHook: hook
                    })
                    .addTo(smc)
                    .setClassToggle(el, "in-view");

                smcScenes.push(s);
            });
        },
        // }}}
        // {{{ setupSlideshow
        setupSlideshow: function() {
            var $slideshows = $(".header.slider:not(.slick-initialized)").each( function() {
                var $slideshow = $(this);
                var $headlines = $slideshow.find("h2");
                var controls = $slideshow.hasClass("with-controls");

                var topicsPage = $("body").hasClass("page-id-5233");
                topicsPage = false;

                $slideshow.slick({
                    dots: true,
                    arrows: false,
                    adaptiveHeight: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    fade: true,
                    dots: controls,
                    customPaging : function(slider, i) {
                        var text = $headlines.eq(i).text();
                        var imageName = "icon-" + text.toLowerCase()
                            .replace(/[^a-zäöü0-9]+/g, "-")
                            .replace(/ä/g, "ae")
                            .replace(/^-|-$/g, "");

                        if (!topicsPage) {
                            //imageName += "-white.svg";
                        } else {
                            //imageName += ".svg";
                        }

                        var icon = "/wp-content/themes/zds/assets/images/" + imageName;
                        return '<button class="wp-block-button ' + imageName + '">' + 
                            //'<img class="icon" src="' + icon + '" alt="" />' +
                            '<span class="wp-block-button__link">' +
                                text +
                            '</span>' +
                        '</button>';
                    },
                });

                if (controls) {
                    $slideshow.append('<div class="button-scroll-white"><a class="wp-block-button__link">Scrollen</a></div>');
                    $slideshow.on("slick beforeChange", function(event, slick, currentSlide){
                        resetProgress();

                        window.requestAnimationFrame(updateProgress);
                    });


                    var $progress = $('<div class="slick-progress running"></div>').appendTo($slideshow);

                    var currentSlide = 0;
                    var duration = 7000;
                    var progress = 0;
                    var running = true;
                    var lastTime = new Date().getTime();

                    $progress.on("click", function() {
                        togglePlay();
                    });

                    function updateProgress() {
                        var currentTime = new Date().getTime();
                        var delta = currentTime - lastTime;
                        lastTime = currentTime;


                        progress += delta;

                        $progress[0].style.setProperty("--progress", (progress / duration).toString());

                        if (progress >= duration) {
                            resetProgress();

                            currentSlide = (currentSlide + 1) % $headlines.length;
                            $slideshow.slick("slickGoTo", currentSlide);
                        }

                        if (running) {
                            window.requestAnimationFrame(updateProgress);
                        }
                    }

                    function resetProgress() {
                        progress = 0;
                        lastTime = new Date().getTime();
                    }

                    function togglePlay() {
                        if (!running) {
                            lastTime = new Date().getTime();

                            window.requestAnimationFrame(updateProgress);
                        }
                        running = !running;
                        $progress.toggleClass("running", running);
                    }

                    window.requestAnimationFrame(updateProgress);
                }
            });
        },
        // }}}
        // {{{ setupNewsSlider
        setupNewsSlider: function() {
            var $slideshows = $(".news-slider .wp-block-post-template:not(.slick-initialized)").each( function() {
                var $slider = $(this);

                $slider.slick({
                    dots: false,
                    arrows: true,
                    autoplay: false,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    variableWidth: true,
                    infinite: false,
                    fade: false,
                    responsive: [
                        {
                            breakpoint: 1600,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });
            });
        },
        // }}}
        // {{{ setupInternalLinks
        setupInternalLinks: function() {
            $('a[href^="#"]').on('click', function (event) {
                event.preventDefault();

                $('html, body').animate({
                    scrollTop: $($.attr(this, 'href')).offset().top
                }, 500);
            });
        },
        // }}}
        // {{{ setupScrollButton
        setupScrollButton: function() {
            $(".button-scroll, .button-scroll-white").on("click", function() {
                var $nextSection = $(this).parents(".wp-block-columns, header.slider").next();

                $('html, body').animate({
                    scrollTop: $nextSection.offset().top
                }, 500);
            });
        },
        // }}}
        // {{{ setupDownloads
        setupDownloads: function() {
            let maxFiles = 3;
            let $downloads = $(".downloads");
            let $files = $downloads.children(".wp-block-file");

            if ($files.length > maxFiles) {
                $files.slice(maxFiles).hide();
                let $more = $('<button class="more" aria-expanded="false">Mehr anzeigen</button>').appendTo($downloads);

                $more.on("click", function() {
                    if ($more.attr("aria-expanded") == "false") {
                        $files.show();
                        $more.attr("aria-expanded", "true");
                        $more.text("Weniger anzeigen");
                    } else {
                        $files.slice(maxFiles).hide();
                        $more.attr("aria-expanded", "false");
                        $more.text("Mehr anzeigen");
                        $('html, body').animate({
                            scrollTop: $downloads.offset().top
                        }, 500);
                    }
                }
                );
            }
        },
        // }}}
        // {{{ setupCountUp
        setupCountUp: function() {
            let $numbers = $(".number strong");
            $numbers.each( function() {
                let endVal = parseInt($(this).text().replace(/\./g, ''));
                const countUp = new CountUp(this, endVal, { enableScrollSpy: true });
            });
        },
        // }}}
        // {{{ setupMap
        setupMap: function() {
            $(".location-map .location-id").on("click", function() {
                var $location = $(this).parents(".location");

                if ($location.hasClass("active")) {
                    localJS.hideLocation($location);
                } else {
                    localJS.showLocation($location);
                }
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest(".location").length) {
                    localJS.hideLocation($(".location-map .location.active"));
                }
            });
        },
        // }}}
        // {{{ showLocation
        showLocation: function($location) {
            localJS.hideLocation($(".location-map .location.active"));

            $location
                .addClass("active");
            $location.children(".location-id")
                .attr("aria-expanded", "true");
            $location
                .children(".location-details")
                .attr("aria-hidden", "false");
        },
        // }}}
        // {{{ hideLocation
        hideLocation: function($location) {
            $location
                .removeClass("active");
            $location.children(".location-id")
                .attr("aria-expanded", "false");
            $location
                .children(".location-details")
                .attr("aria-hidden", "true");
        },
        // }}}
        // {{{ setupDetails
        setupDetails: function() {
            $(".details").depageDetails({
                "head": "h3, h4"
            });
        },
        // }}}
        // {{{ setupContacts
        setupContacts: function() {
            $(".has-more").on("click", ".contact", function() {
                var $contact = $(this);

                if ($contact.hasClass("active")) {
                    $contact.removeClass("active");
                } else {
                    $(".contact.active").removeClass("active");
                    $contact.addClass("active");
                }
            });

            $("body").on("click", function(e) {
                if (!$(e.target).closest(".contact").length) {
                    $(".contact.active").removeClass("active");
                }
            });
        },
        // }}}
        // {{{ setupShare
        setupShare: function() {
            if (!navigator.canShare) {
                return;
            }

            var $share = $("<a class=\"share\" title=\"Share\">Share</a>");

            let shareData = {
                title: document.title,
                text: document.title,
                url: location.href
            }

            $share.on('click', function() {
                navigator.share(shareData).then(() => {
                    console.log("shared");
                })
                .catch((e) => {
                    console.log('error: ' + e)
                });
            });

            $share.clone(true).insertAfter("footer.bottom .twitter");
            $share.clone(true).appendTo(".share-container");
        }
        // }}}
    };

    return localJS;
})();

// {{{ register ready event
$(function() {
    zds.ready();
});
// }}}

// vim:set ft=javascript sw=4 sts=4 fdm=marker :
